import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import { isIOSDevice } from "../../utils/app-helpers";

const { siteMetadata: config } = GatsbyConfig;

export default class SocialBar extends React.Component {
  print = () => {
    if (typeof window === "undefined") return;
    window.print();
  };

  render() {
    const { trip } = this.props;
    const tripData = config.trips[trip];
    const isIOS = isIOSDevice();

    return (
      <div className="social-bar">
        <div className="wrap">
          <a onClick={this.print}>
            <i className="fa fa-print" />
            <span>Print</span>
          </a>
          <a href={`mailto:${config.email}`}>
            <i className="fa fa-envelope" />
            <span>Email</span>
          </a>
          {!!tripData.mapUrl && (
            <a target="_blank" href={tripData.mapUrl}>
              <i className="fa fa-map-marker" />
              <span>
                <span className="verbose">See on </span>Map
              </span>
            </a>
          )}
          <a
            target={isIOS ? undefined : "_blank"}
            href={config.urls[isIOS ? "facebookApp" : "facebook"]}
          >
            <i className="fa fa-facebook-square" />
            <span>
              <span className="verbose">Join us on </span>Facebook
            </span>
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/social-bar.js